import { render, staticRenderFns } from "./UsersPrivilegeEmployeesSettlementMovement.vue?vue&type=template&id=221a5800&scoped=true&"
import script from "./UsersPrivilegeEmployeesSettlementMovement.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployeesSettlementMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a5800",
  null
  
)

export default component.exports